import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import config from 'config';
import gather from '../../tools/gather';

export const getProfile = createAsyncThunk('getProfile', async () => {
  return await gather(`${config.apiUrl}/user`, true).get();
});

export const loadingSlice = createSlice({
  name: 'user',
  initialState: {
    profile: {
      email: '',
      balanceAmount: 0,
      trx: {} as any,
    },
  },
  reducers: {
    updateWallet: (state, action) => {
      state.profile.balanceAmount = action.payload.balanceAmount;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProfile.fulfilled, (state, action) => {
      state.profile = action.payload.data as any;
    });
  },
});

export const { updateWallet } = loadingSlice.actions;
export default loadingSlice.reducer;
